<button *ngIf="!isLoggedIn && !iconOnly"
        [ngClass]="buttonClasses"
        class="btn"
        (click)="onClick()"
        [textContent]="typeCta | label">
</button>

<div #menuContainer
     *ngIf="iconOnly"
     [class.opened]="menuOpened"
     class="login-menu"
>
  <div class="login-menu__icon"></div>
  <div *ngIf="isLoggedIn"
       class="login-menu__arrow"></div>

  <div *ngIf="isLoggedIn"
       class="login-menu__overlay">
    <a class="login-menu__overlay-cta"
       [routerLink]="myAccountUrl"
       [textContent]="'my_account' | label"></a>
    <a class="login-menu__overlay-cta"
       (click)="onLogOut($event)"
       [textContent]="'logout' | label"></a>
  </div>
</div>
